import { useMutation } from 'react-query'
import { ApiService } from '../../api'
import { queryClient } from '../../react-query-provider/ReactQueryClientProvider'

export const useMarkNotificationAsRead = () => {
  return useMutation(
    ({ id }: { id: number }) => ApiService.Notifications.endpoints.markAsRead(id),
    {
      onSuccess: () => queryClient.invalidateQueries(['notifications'])
    }
  )
}
